import './wp-arena-minimap.scss';

import Vue, { VueConstructor } from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Prop, DefaultProps } from 'vue/types/options';
import WpBaseComponent from '../../../../wp-base-component';
import { Watch } from 'vue-property-decorator';
import { Transform } from 'panzoom';
import html2canvas from 'html2canvas';
import GlobalService from 'web-platform-core-ui/src/Global/global-service';
import { AppSettings } from 'web-platform-core-ui/src/Global/app-settings';

export const wpArenaMinimapProp = Vue.extend({
    props: {
        data: Object as Prop<any>,
        trigger: Boolean,
        transform: Object as Prop<Transform>,
        arenaposition: Number,
    }
})

@Component({
    template: require("./wp-arena-minimap.html")
})
export default class WpArenaMinimap extends mixins<WpBaseComponent, DefaultProps, VueConstructor>(WpBaseComponent, Vue, wpArenaMinimapProp) {
    Settings!: AppSettings;
    Lens: Lens | null = null;
    Map!: HTMLElement;
    Viewport!: HTMLElement;
    Width: number = 0;
    MaxWidth: number = 320;
    Height: number = 0;
    TouchDown: boolean = false;
    AspectRatio: number = 1;
    MinimapVisible: boolean = true;
    MinimapEnabled: boolean = true;

    @Watch("trigger")
    Trigger(): void {
        if (!this.transform || !this.Lens) return;
        this.Lens.Navigate(this.transform, this.Viewport);
    };

    @Watch("data")
    DataChanged(n: any): void {
        if (!this.Map) return;
        this.RenderMinimap();
    };

    @Watch("transform")
    TransformChanged(T: Transform): void {
        if (this.Lens) this.Lens.Navigate(T, this.Viewport);
    };

    created(): void {
        this.Settings = GlobalService.GetSettings<AppSettings>();
        this.MinimapEnabled = this.Settings.Minimap;
    };

    mounted(): void {
        if (!this.MinimapEnabled) return;
        this.Map = <HTMLElement>this.$refs.minimap;
        this.Map.addEventListener("wheel", (e: WheelEvent) => {
            e.preventDefault();
            this.$emit("WheelEvent", e);
        });
        this.Viewport = document.getElementById("seats_wrap") as HTMLElement;
    };

    protected MinimapClick(e: PointerEvent, smooth?: boolean): void {
        if (!this.Lens) return;
        if (smooth) {
            this.$emit("MoveSmooth", this.Lens.Move(e));
        } else {
            this.$emit("Move", this.Lens.Move(e));
        };
    };

    protected MouseUp(e: any): void {
        if (this.TouchDown) {
            this.MinimapClick(e);
            this.TouchDown = false;
        };
    };

    protected MouseMove(e: any): void {
        if (this.TouchDown && this.Lens) {
            this.Lens.Move(e, true);
        };
    };

    protected RenderMinimap(): void {
        // Converting div to canvas to render seats
        console.log("Rendering minimap...");

        if (!html2canvas) {
            console.log(html2canvas);
            console.error("html2canvas is not installed");
            return;
        };

        let seats_block = <HTMLElement>document.getElementById("seats_block");
        let aspectRatio = this.Settings.MinimapAspect;
        if (this.MinimapEnabled && seats_block) {
            html2canvas(seats_block, {
                scale: aspectRatio,
            }).then((result: any) => {
                this.AspectRatio = 1 / aspectRatio;
                result.style.width = "30vw";
                result.style.height = "30vh";
                this.Map.appendChild(result);
                this.Lens = Lens.Create(this.Viewport, this.AspectRatio);
                this.Lens.UpdateSize();
            });
        };
    };
};
//todo: линза уезжает за пределы миникарты после уменьшения размера, хз как фиксить пока
class Lens {
    private static Instance: Lens;
    private x: number = 0;
    private y: number = 0;
    private s: number = 1;
    private Width: number = 100;
    private Height: number = 100;
    private Viewport!: HTMLElement;
    private AspectRatio: number = 1;
    // This is width of rows to the left of original map
    // Should be found with query selector, not hardcoded
    SidebarWidth: number = 35;

    private constructor() {
        // Disable new() keyword
    };

    static Create(viewport: HTMLElement, aspectRatio?: number): Lens {
        if (!this.Instance) this.Instance = new Lens();
        this.Instance.Viewport = viewport;
        if (aspectRatio) this.Instance.AspectRatio = aspectRatio;
        return this.Instance;
    };

    Navigate(T: Transform, viewport: HTMLElement): void {
        this.x = (0 - T.x / this.AspectRatio + 35 / this.AspectRatio) / T.scale;
        this.y = 0 - T.y / this.AspectRatio / T.scale;
        this.s = T.scale;
        this.UpdateSize();
    };

    UpdateSize(): void {
        this.Width = (this.Viewport.clientWidth / this.AspectRatio / this.s - (this.SidebarWidth / this.AspectRatio / this.s)) / 2;
        this.Height = this.Viewport.clientHeight / this.AspectRatio / this.s / 7;
    };

    Move(e: PointerEvent, update?: boolean): any {
        let t = {
            x: (e.offsetX - this.Width / 2) * this.AspectRatio,
            y: (e.offsetY - this.Height / 2) * this.AspectRatio,
            scale: this.s
        };
        if (update) {
            this.x = e.offsetX - this.Width / 2;
            this.y = e.offsetY - this.Height / 2;
        };
        return t;
    };
};